

const REFERRAL_KEY = "veyra_referral";
const PENDING_REFERRAL_KEY = "pending_referral";

export function captureReferralCode(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get("ref");

  if (refCode) {

    localStorage.setItem(REFERRAL_KEY, refCode);
    console.log("Referral code captured:", refCode);
  }
}

export function getReferralCode(): string | null {
  return localStorage.getItem(REFERRAL_KEY);
}

export function clearReferralCode(): void {
  localStorage.removeItem(REFERRAL_KEY);
}

export function generateReferralLink(userId: string): string {
  const baseUrl = window.location.origin;
  return `${baseUrl}/?ref=${userId}`;
}

export async function retryPendingReferral(
  authToken: string
): Promise<boolean> {
  const pendingData = localStorage.getItem(PENDING_REFERRAL_KEY);

  if (!pendingData) {
    return false;
  }

  try {
    const { referrerId, newUserId, timestamp } = JSON.parse(pendingData);

    if (Date.now() - timestamp > 7 * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(PENDING_REFERRAL_KEY);
      return false;
    }

    const response = await fetch(
      "https://us-central1-veyra-200d7.cloudfunctions.net/v2Api/manageReferrals",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          action: "track",
          referrerId,
          newUserId,
        }),
      }
    );

    if (response.ok) {
      const data = await response.json();
      if (data.success) {
        console.log("Pending referral tracked successfully");
        localStorage.removeItem(PENDING_REFERRAL_KEY);
        return true;
      }
    }

    throw new Error("Failed to track pending referral");
  } catch (error) {
    console.error("Error retrying pending referral:", error);
    return false;
  }
}
